import { removeNotification } from 'actions';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { getNotifications } from 'selectors';
import { Notification } from './Notification/Notification';
import './Notifications.scss';
import type { RootState } from 'reducers/types';

type PropsFromRedux = ConnectedProps<typeof connector>;

const NotificationsComponent = ({
  notifications = [],
  removeNotification,
}: PropsFromRedux) => (
  <div className="Notifications">
    <div className="Notifications-wrapper">
      {notifications.map(notification => {
        const { id, message, type } = notification;
        return (
          <Notification
            key={id}
            message={message}
            onClose={() => removeNotification(id)}
            type={type}
          />
        );
      })}
    </div>
  </div>
);

const mapStateToProps = (state: RootState) => {
  const notifications = getNotifications(state);

  return { notifications };
};

const mapDispatchToProps = {
  removeNotification,
};
const connector = connect(mapStateToProps, mapDispatchToProps);
export const Notifications = connector(NotificationsComponent);
